/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Physics12Inputs */

const en__field_enum_study_physics12 = /** @type {(inputs: _Field_Enum_Study_Physics12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physics`)
};

const de__field_enum_study_physics12 = /** @type {(inputs: _Field_Enum_Study_Physics12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physik`)
};

/**
* | output |
* | --- |
* | "Physics" |
*
* @param {_Field_Enum_Study_Physics12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_physics12 = /** @type {((inputs?: _Field_Enum_Study_Physics12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Physics12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_physics12(inputs)
	return de__field_enum_study_physics12(inputs)
});
export { _field_enum_study_physics12 as "_field_enum_STUDY_PHYSICS" }